<template>
  <transition :name="value !== undefined ? 'extra' : 'fade'" key="tooltip">
    <div v-if="showTooltip" ref="tooltip" class="bim-tooltip" :class="positionTooltip" :style="`width: ${computedWidth};`">
      <!-- @slot Текст сообщения в формате html -->
      <div :style="`text-align: ${align}`">
        <slot/>
      </div>
      <svg v-if="!hideArrow" class="triangle" width="40" height="15">
        <polygon points="0,0 20,15 40,0" />
      </svg>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'bimTooltip',
  props: {
    /**
     * Позиционирование родителя. На случай, если родитель должен иметь position: absolute и пр.
     * @values 'relative', 'absolute', 'fixed', 'sticky'
     */
    parentPosition: {
      type: String,
      default: 'relative',
      validator (value) {
        return ['relative', 'absolute', 'fixed', 'sticky'].indexOf(value) !== -1
      },
    },
    /**
     * Используется в случае, если нужно включать подсказку после какого-то события. Например при валидации
     * @model
     */
    value: {
      type: Boolean,
      default: undefined,
    },
    /**
     * Направление текста
     */
    align: {
      type: String,
      default: 'center',
      validator (value) {
        return ['center', 'left', 'right', 'justify', 'justify-all', 'initital', 'inherit'].indexOf(value) !== -1
      },
    },
    /**
     * Ширина
     */
    width: {
      type: [String, Number],
      default: '270'
    },
    /**
     * Позиционирование тултипа
     * @values top, bottom
     */
    positionTooltip: {
      type: String,
      default: 'top',
      validator: pos => ['top', 'bottom'].includes(pos)
    },
    hideArrow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showTooltip: false,
    }
  },
  mounted () {
    // const parent = this.$refs.tooltip.parentNode
    const parent = this.$el.parentNode
    parent.style.position = this.parentPosition

    if (this.value === undefined) {
      parent.addEventListener('mouseenter', () => {
        this.showTooltip = true
      })

      parent.addEventListener('mouseleave', () => {
        this.showTooltip = false
      })
    } else {
      this.showTooltip = this.value
    }
  },
  watch: {
    value (val) {
      this.showTooltip = val
    },
  },
  computed: {
    computedWidth () {
      if (+this.width) {
        return this.width + 'px'
      } else {
        return this.width
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.bim-tooltip {
  position: absolute;
  left: 50%;
  z-index: 10;

  padding: 10px 14px;

  text-align: center;
  white-space: normal;

  background-color: $white-color;
  border-radius: 5px;
  transform: translate(-50%);

  pointer-events: none;

  @include text-style(14px, normal, 1.57, 0.2px, $black-color);
  .triangle {
    position: absolute;
    left: 50%;
    z-index: 10;

    width: auto;
    height: auto;

    fill: $white-color;
  }
}

.bim-tooltip.top {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  bottom: calc(100% + 21px);

  .triangle {
    bottom: -15px;
    transform: translateX(-50%);
  }
}

.bim-tooltip.bottom {
  box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.15);
  top: calc(100% + 21px);

  .triangle {
    top: -15px;
    transform: translateX(-50%) rotate(180deg);
  }
}

.fade-enter-active {
  transition: 0.2s;
  transition-delay: 0.7s;
}

.fade-leave-active {
  transition: 0.2s;
}
.fade-enter,
.fade-leave-to,
.extra-enter,
.extra-leave-to {
  transition: 0.2s;
  opacity: 0;
}

.extra-enter-active,
.extra-leave-active {
  transition: 0.2s;

  transition-delay: 0s;
}
</style>
